import Image from 'next/image';
import cn from 'classnames';
import { ImageWithCaptionSliceData } from '@adapters/prismic/types/slices';
import Link from 'next/link';
import styles from './ImageWithCaption.module.scss';

const ImageWithCaption = ({
  id,
  image,
  caption,
  link,
  fullWidthImage,
}: ImageWithCaptionSliceData) =>
  image ? (
    <figure
      id={id}
      className={cn(styles.imageWithCaption, {
        [styles.fullWidthImage]: fullWidthImage,
      })}
    >
      <div
        className={styles.imageContainer}
        style={{
          paddingTop: `calc(100% * ${image?.dimensions.height}/${image?.dimensions.width})`,
        }}
      >
        {link?.url ? (
          <Link href={link?.url}>
            <Image
              src={image?.url}
              alt={image?.alt || caption || ''}
              quality={65}
              fill
              sizes="(min-width: 480px) 936px, 480px"
            />
          </Link>
        ) : (
          <Image
            src={image?.url}
            alt={image?.alt || caption || ''}
            quality={65}
            fill
            sizes="(min-width: 480px) 936px, 480px"
          />
        )}
      </div>
      {caption && (
        <figcaption className={styles.imageCaption}>{caption}</figcaption>
      )}
    </figure>
  ) : null;

export default ImageWithCaption;
